export default {
  PERSONAL: 'personal',
  BUSINESS: 'business',
  ONLINE_STORE: 'online-store',
  NON_PROFIT: 'non-profit',
  EVENTS: 'events',
  COMMUNITY: 'community',
  OTHER: 'other',
};
